import { Field } from '@lmt/unicorn-shared/app/components/common/Field';
import { DropDownInput } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/dropdown/DropDownInput';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { useQueryParamsInTab } from '@lmt/unicorn-shared/app/helpers/use-query-params-in-tab';
import React, { useEffect } from 'react';
import { useSubtenants } from '@lmt/unicorn-shared/app/features/subtenants/selectors';
import { NumberParam, withDefault } from 'react-router-url-params';
import styles from './GDTTemplateRulesPage.module.scss';
import { GDTTemplateRulesTable } from './components/GDTTemplateRulesTable';

export const GDTTemplateRulesPage = () => {
  const i18n = useScopedTranslation('gdt.template_rules');
  const subtenants = useSubtenants();

  const [queryParams, setQueryParams] = useQueryParamsInTab({
    subtenantId: withDefault(NumberParam, undefined),
  });

  useEffect(() => {
    if (!subtenants.length) {
      return;
    }

    const subtenant = subtenants.find((s) => s.id === queryParams.subtenantId);
    if (!subtenant) {
      setQueryParams({
        subtenantId: subtenants[0].id,
      });
    }
  }, [subtenants]);

  return (
    <div className={styles.container} data-test-id="gdt-template-rules-page">
      <Field title={i18n.t('subtenant')} className={styles.field}>
        <DropDownInput
          useIdFunctionAsValue={true}
          required
          variant="normal"
          getOptionLabel="name"
          idFunction="id"
          options={subtenants}
          value={queryParams.subtenantId}
          onValueChanged={(option) => {
            setQueryParams({
              subtenantId: option!.id,
            });
          }}
        />
      </Field>
      <div className={styles.table}>
        <GDTTemplateRulesTable subtenantId={queryParams.subtenantId} />
      </div>
    </div>
  );
};
